<template>
  <div v-show="show" class="page-container">
    <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
      <!-- <van-image class="integral-bg" :src="exchangeStoreImg" width="100%" /> -->
      <div class="page-content">
        <div class="middle-bar">
          <div class="left">可用兑换券</div>
          <div class="right" @click="navigateTo('/myExchangeCoupon')">
            <div>{{ totalExchangeCount }}</div>
            <van-icon color="#999" name="arrow" :size="transPxToRem(12)" />
          </div>
        </div>
        <div class="content-box">
          <van-list
            class="list-container"
            v-model:loading="loading"
            :finished="finished"
            :finished-text="finishedText"
            :immediate-check="false"
            @load="getList"
          >
            <div class="goods-list con-wrp">
              <div
                v-for="item in list"
                :key="item.goodsId"
                class="goods-list-item"
                @click="goGoodsDetails(item.goodsId, Boolean(item.stock))"
              >
                <div class="image-wrp">
                  <van-image :src="item.goodsMainImg" :width="transPxToRem(171)" :height="transPxToRem(171)" />
                  <div class="image-cover" v-if="!Boolean(item.stock)">
                    <van-image :src="exchangedIcon" :width="transPxToRem(171)" :height="transPxToRem(171)" />
                  </div>
                </div>
                <div class="content-wrp">
                  <div class="title van-multi-ellipsis--l2">{{ item.goodsName }}</div>
                  <div class="del-price">原价 ￥{{ item.marketingPrice }}</div>
                  <div class="price">
                    <span class="coupon-price-num">{{ item.couponNum }}</span
                    >兑换券<template v-if="item.salePrice">+<Price :price="item.salePrice" />元</template>
                  </div>
                </div>
              </div>
            </div>
          </van-list>
          <van-empty
            v-if="list.length == 0 && !loading"
            image-size="240"
            image="https://i.xurl.cn/x_dsx_wxapp/empty/result.png"
            description="暂无数据"
          />
        </div>
      </div>
    </van-pull-refresh>
  </div>
</template>
<script setup>
import { ref, onMounted, reactive, computed, onBeforeMount } from 'vue'
import { getExchangeGoodsListApi, getMyExchangeCouponInfoApi } from '@/api/coupon'
// import exchangeStoreImg from '@/assets/img/exchange-store-img.png'
import exchangedIcon from '@/assets/img/exchanged.png'
import GoldCoin from '@/assets/img/gold_coin.png'
import { transPxToRem } from '@/utils'
import usePage from '@/hooks/usePage'
import { WxPage } from '../../enum'
import Price from '@/components/Price.vue'
import { useUserStore } from '@/store/user'
import { showDialog } from 'vant'
const show = ref(false)
const totalExchangeCount = ref(0)
const { navigateTo } = usePage()
const { goWxAppPage } = usePage()
const userStore = useUserStore()

const pageParams = reactive({
  page: 1,
  pageSize: 20
})
const postParams = ref({})
const loading = ref(false)
const finished = ref(false)
const list = ref([])
const finishedText = computed(() => (list.value.length ? '到达地平线' : ''))

const reset = () => {
  list.value = []
  pageParams.page = 1
  finished.value = false
}
const getList = async () => {
  loading.value = true
  try {
    const params = { ...pageParams, ...postParams.value }
    const resData = await getExchangeGoodsListApi(params)
    list.value.push(...resData.list)
    pageParams.page++
    finished.value = list.value.length === Number(resData.total)
  } catch {
    finished.value = true
  } finally {
    loading.value = false
  }
}

const goGoodsDetails = (goodsId, isExchange = false) => {
  isExchange && goWxAppPage(`${WxPage.goodsDetails}?goodsId=` + goodsId + '&comeType=10')
}

const refreshing = ref(false)
const onRefresh = async () => {
  refreshing.value = true
  try {
    reset()
    getList()
  } finally {
    refreshing.value = false
  }
}

const getExchangeInfo = async () => {
  const resData = await getMyExchangeCouponInfoApi({})
  if (resData) {
    totalExchangeCount.value = resData.exchangeCouponNum
  }
}
onMounted(async () => {
  try {
    getList()
    getExchangeInfo()
  } catch (e) {
    console.log(e)
  }
})
onBeforeMount(() => {
  if (userStore.getSettingInfo?.isShowExchangeCoupon) {
    show.value = true
    return
  }
  showDialog({
    title: '温馨提示',
    message: '暂无权限访问该页面，请联系客服',
    confirmButtonText: '知道啦'
  }).then(() => {
    wx.miniProgram.navigateBack()
  })
})
</script>
<style lang="less" scoped>
.page-container {
  font-size: 14px;
  background-color: #f6f6f6;
  height: fit-content;
  min-height: 100vh;
  // background-image: url(/@/assets/img/exchange-store-img.png);
  background-image: url(../../assets/img/exchange-store-img.png);
  background-position: top;
  background-size: 100vw 230px;
  background-repeat: no-repeat;
  padding-top: 210px;
  .page-content {
    padding-top: 12px;
    background-color: #f6f6f6;
    border-radius: 20px 20px 0px 0px;
  }
  .middle-bar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    background-color: #fff;
    border-radius: 8px;
    padding: 14px 12px;
    margin: 0 12px;
    .left {
      display: flex;
      align-items: center;
      .title {
        color: #222;
        font-weight: 500;
        margin: 0 8px;
        line-height: 22px;
      }
      .num {
        color: #ff6060;
        font-weight: 800;
        line-height: 24px;
        font-size: 24px;
      }
    }
    .right {
      display: flex;
      align-items: center;
      .right-label {
        color: #999999;
      }
    }
  }
  .content-box {
    //background: #ffffff;
    border-radius: 8px;
    overflow: hidden;
    margin: 12px;
    .goods-list {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      // padding: 16px 12px;
      .goods-list-item {
        margin-bottom: 16px;
        max-width: 171px;
        background-color: #fff;
        border-radius: 8px;
        overflow: hidden;
        .image-wrp {
          position: relative;
          height: 171px;
          .image-cover {
            position: absolute;
            top: 0;
            width: 100%;
            height: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
            background: rgba(0, 0, 0, 0.4);
          }
        }
        .content-wrp {
          padding: 10px;
          .title {
            font-weight: bold;
            color: #222222;
            line-height: 22px;
            max-width: 100%;
            height: 44px;
          }
          .del-price {
            color: #999999;
            font-size: 12px;
          }
          .price {
            color: #ff5b6f;
            font-weight: 500;
            .coupon-price-num {
              font-size: 16px;
            }
          }
        }
      }
    }
    .coupon-list {
      margin-top: 16px;
      .coupon-list-item {
        margin: 12px;
        display: flex;
        align-items: center;
        margin-bottom: 12px;
        justify-content: space-between;
        align-items: stretch;
        .left {
          border-top-left-radius: 8px;
          border-bottom-left-radius: 8px;
          background: #f6f6f6;
          padding-left: 4px;
          padding-right: 4px;
          padding-top: 10px;
          padding-bottom: 10px;
          // height: 84px;
          display: flex;
          .price {
            color: #ff6060;
            font-size: 11px;
            flex-direction: column;
            display: flex;
            align-items: center;
            width: 80px;
            .condition {
              margin-top: 2px;
            }
          }
        }
        .divider {
          border-right: 1px dashed #d8d8d8;
          height: 72px;
          position: relative;
          top: 7px;
        }
        .des {
          border-top-right-radius: 8px;
          border-bottom-right-radius: 8px;
          color: #999999;
          background: #f6f6f6;
          flex: 1;
          display: flex;
          flex-direction: column;
          justify-content: center;
          line-height: 16px;
          padding-top: 16px;
          padding-bottom: 16px;
          font-size: 12px;
          .title {
            color: #222;
            font-weight: bold;
            font-size: 14px;
            max-width: 120px;
            // padding-right: 23px;
            margin-bottom: 8px;
          }
          .condition {
            margin: 4px 0;
          }
        }
        .right {
          background: #f6f6f6;
          text-align: center;
          display: flex;
          flex-direction: column;
          justify-content: center;
          border-radius: 8px;
          width: 100px;
          align-items: center;
          .num-box {
            display: flex;
            align-items: center;
          }
          .num {
            color: #ff6060;
            font-weight: 800;
            margin-left: 2px;
          }
          .btn {
            width: 68px;
            height: 28px;
            background: #ffffff;
            // border-radius: 4px;
            font-size: 12px;
            margin-top: 6px;
            padding: 0;
          }
        }
      }
    }
  }
}
</style>
